import { isEqual } from "lodash";
import memoize from "memoizee";
import React, { Component } from "react";

import Checkbox from "./Checkbox";
import ErrorMessage from "./Layout/ErrorMessage";
import InputContainer from "./Layout/InputContainer";
import InputLabel from "./Layout/InputLabel";

import { useResources } from "@aetonix/hooks";

class CheckboxesComp extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: props.defaultValue || [],
			selectAllValue: false
		};

		this.handleChange = memoize(makeChanger.bind(this));
		this.handleSelectAll = memoize(makeSelectAllChange.bind(this));
	}

	componentDidUpdate(prevProps) {
		const oldDefaultValue = prevProps.DefaultValue;
		const currentDefaultValue = this.props.defaultValue;

		if (!isEqual(currentDefaultValue, oldDefaultValue) && !isEqual(currentDefaultValue, this.state.data)) {
			this.setState({ data: currentDefaultValue });
		}
	}

	render() {
		const props = this.props;
		const localize = props.localize;
		const localizeFrom = props.localizeFrom;
		const contrast = props.contrast;
		const errors = props.errors;
		const schema = props.schema || {};
		const state = this.state;
		const id = props.id;
		const selectAll = schema.selectAll;
		const selectAllValue = this.state.selectAllValue;

		const items = schema.items || {};

		const options = Array.isArray(items.enum) ? items.enum : [];
		let valueLocalization = items.value_localization || items.valueLocalization;
		if (!valueLocalization) valueLocalization = items.value_description;

		const renderOptions = options.map(
			function (option) {
				const handleChange = this.handleChange(option);
				const defaultValue = state.data.indexOf(option) !== -1;
				const title = localizeFrom(valueLocalization, option) || localize(valueLocalization + "." + option) || option;
				return (
					<Checkbox
						key={option + defaultValue}
						id={id + "_" + option}
						contrast={contrast}
						defaultValue={defaultValue}
						title={title}
						onChange={handleChange}
						noInputContainer
					/>
				);
			}.bind(this)
		);

		const titleSelectAll = selectAllValue ? localize("common.unselectall") : localize("common.selectall");
		const handleSelectAll = this.handleSelectAll(options);
		const renderSelectAll = selectAll && renderOptions.length;
		const renderSelectAllButton = renderSelectAll ? (
			<Checkbox
				key={titleSelectAll + "_" + "key"}
				id={id + "_" + "select_all"}
				contrast={contrast}
				defaultValue={selectAllValue}
				title={titleSelectAll}
				onChange={handleSelectAll}
				noInputContainer
				bold
			/>
		) : null;

		return (
			<InputContainer>
				<ErrorMessage errors={errors} schema={schema} />
				<InputLabel schema={schema} />
				{renderSelectAllButton}
				{renderOptions}
			</InputContainer>
		);
	}
}

function makeSelectAllChange(options) {
	return (selectAllValue) => {
		let data = this.state.data || [];
		const onChange = this.props.onChange;
		if (selectAllValue) {
			data = options;
		} else {
			data = [];
		}
		if (onChange) onChange(data);

		this.setState({
			data,
			selectAllValue
		});
	};
}

function makeChanger(option) {
	return (value) => {
		let data = this.state.data || [];
		const onChange = this.props.onChange;
		if (value) data = data.concat(option);
		else data = data.filter((el) => el !== option);

		if (onChange) onChange(data);

		this.setState({
			data: data
		});
	};
}

export default function Checkboxes(props){
	const { localize, localizeFrom } = useResources();
	return <CheckboxesComp {...props} localize={localize} localizeFrom={localizeFrom} />;
}